// extracted by mini-css-extract-plugin
export default {"paginationList":"_6ff3c95b","paginationItem":"_b504dc0c","page":"_35ea4986","arrowWrapper":"_c156279f"};